import {DiplomatObjectNames} from 'types/diplomat-object';

export const TransactionIdNames = {
   name: DiplomatObjectNames.name,
   description: 'description',
} as const;

export const FileInformationNames = {
   sourceDateFormat: 'sourceDateFormat',
   destinationDateFormat: 'destinationDateFormat',
   sourceDateRange: 'sourceDateRange',
   destinationDateType: 'destinationDateType',
   sourceTimeRange: 'sourceTimeRange',
   overwriteType: 'overwriteType',
   removeSourceDate: 'removeSourceDate',
   removeSourceSequence: 'removeSourceSequence',
   allowZeroLength: 'allowZeroLength',
   transferOrder: 'transferOrder',
   failIfFilesNotFound: 'failIfFilesNotFound',
   translateInvalidChars: 'translateInvalidChars',
   sourceMoveSuccessPath: 'sourceMoveSuccessPath',
   sourceMoveErrorPath: 'sourceMoveErrorPath',
   fileDescriptors: 'fileDescriptors',
   followLinks: 'followLinks',
   _postTransferChoice: '_postTransferChoice',
} as const;

export const TransactionPartnerNames = {
   sourcePartner: 'sourcePartner',
   sourcePartnerId: 'sourcePartnerId',
   // destinationPartner: 'destinationPartner',
   // destinationPartnerId: 'destinationPartnerId',
   destinationPartners: 'destinationPartners',
   destinationPartnerIds: 'destinationPartnerIds',
} as const;

export const FileHandlingNames = {
   encryptDecrypt: 'encryptDecrypt',
   signAuthenticate: 'signAuthenticate',
   onePassSignature: 'onePassSignature',
   aekIds: 'aekIds',
   asciiArmoring: 'asciiArmoring',
   pgpcomment: 'pgpcomment',
   compression: 'compression',
   canonicalText: 'canonicalText',
   sourceFtpMode: 'sourceFtpMode',
   destinationFtpMode: 'destinationFtpMode',
   integrityProtect: 'integrityProtect',
   deleteUnencryptedSourceFiles: 'deleteUnencryptedSourceFiles',
} as const;

export const ScheduleNames = {
   schedule: 'schedule',
} as const;

export const TransactionNames = {
   name: TransactionIdNames.name,
   description: TransactionIdNames.description,
   type: 'type',

   sourceDateFormat: FileInformationNames.sourceDateFormat,
   destinationDateFormat: FileInformationNames.destinationDateFormat,
   sourceDateRange: FileInformationNames.sourceDateRange,
   destinationDateType: FileInformationNames.destinationDateType,
   sourceTimeRange: FileInformationNames.sourceTimeRange,
   overwriteType: FileInformationNames.overwriteType,
   removeSourceDate: FileInformationNames.removeSourceDate,
   removeSourceSequence: FileInformationNames.removeSourceSequence,
   allowZeroLength: FileInformationNames.allowZeroLength,
   transferOrder: FileInformationNames.transferOrder,
   failIfFilesNotFound: FileInformationNames.failIfFilesNotFound,
   translateInvalidChars: FileInformationNames.translateInvalidChars,
   sourceMoveSuccessPath: FileInformationNames.sourceMoveSuccessPath,
   sourceMoveErrorPath: FileInformationNames.sourceMoveErrorPath,
   fileDescriptors: FileInformationNames.fileDescriptors,
   followLinks: FileInformationNames.followLinks,

   sourcePartner: TransactionPartnerNames.sourcePartner,
   sourcePartnerId: TransactionPartnerNames.sourcePartnerId,
   // destinationPartner: TransactionPartnerNames.destinationPartner,
   // destinationPartnerId: TransactionPartnerNames.destinationPartnerId,
   destinationPartners: TransactionPartnerNames.destinationPartners,
   destinationPartnerIds: TransactionPartnerNames.destinationPartnerIds,

   encryptDecrypt: FileHandlingNames.encryptDecrypt,
   signAuthenticate: FileHandlingNames.signAuthenticate,
   onePassSignature: FileHandlingNames.onePassSignature,
   aekIds: FileHandlingNames.aekIds,
   asciiArmoring: FileHandlingNames.asciiArmoring,
   pgpcomment: FileHandlingNames.pgpcomment,
   compression: FileHandlingNames.compression,
   canonicalText: FileHandlingNames.canonicalText,
   sourceFtpMode: FileHandlingNames.sourceFtpMode,
   destinationFtpMode: FileHandlingNames.destinationFtpMode,
   integrityProtect: FileHandlingNames.integrityProtect,
   deleteUnencryptedSourceFiles: FileHandlingNames.deleteUnencryptedSourceFiles,

   schedule: ScheduleNames.schedule,

   attemptSourceDelete: 'attemptSourceDelete',
   warnAek: 'warnAek',

   notifications: 'notifications',
   slackWebhookUrl: 'slackWebhookUrl',
   slackNotificationType: 'slackNotificationType',
   teamsWebhookUrl: 'teamsWebhookUrl',
   teamsNotificationType: 'teamsNotificationType',

   webhookEnabled: 'webhookEnabled',
   webhookUrl: 'webhookUrl',
   webhookNotificationType: 'webhookNotificationType',

   archive: 'archive',
   troubleShooting: 'troubleShooting',
   preCommand: 'preCommand',
   postCommand: 'postCommand',
   attemptSourceMove: 'attemptSourceMove',
   zipParameters: 'zipParameters',
   daisyChainedCommand: 'daisyChainedCommand',
} as const;
